import apiClient from '../api/axios';

export interface CreateRolePayload {
  title: string;
  description: string;
}

export interface UpdateRolePayload {
  title: string;
  description: string;
}

// Create Role
export const createRole = async (data: CreateRolePayload) => {
  const response = await apiClient.post('/admin/roles', data);

  return response.data;
};

// Get All Roles
export const getRoles = async () => {
  const response = await apiClient.get('/admin/roles');

  return response.data;
};

// Get Role By Id
export const getRoleById = async (id: string) => {
  const response = await apiClient.get(`/admin/roles/${id}`);

  return response.data;
};

// Update Role
export const updateRole = async (id: string, data: UpdateRolePayload) => {
  const response = await apiClient.put(`/admin/roles/${id}`, data);

  return response.data;
};

// Delete Role (optional if backend supports it)
export const deleteRole = async (id: string) => {
  const response = await apiClient.delete(`/admin/roles/${id}`);

  return response.data;
};
